var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _rect, _g, _g2, _path, _rect2, _rect3, _rect4, _rect5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 604,
    height: 220,
    viewBox: "0 0 604 220",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 99.5,
    y1: 209.5,
    x2: 504.5,
    y2: 209.5,
    stroke: "url(#paint0_linear_4416_32947)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 45.5,
    y1: 180.5,
    x2: 558.5,
    y2: 180.5,
    stroke: "url(#paint1_linear_4416_32947)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 151.5,
    x2: 585.5,
    y2: 151.5,
    stroke: "url(#paint2_linear_4416_32947)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 122.5,
    x2: 602.5,
    y2: 122.5,
    stroke: "url(#paint3_linear_4416_32947)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 94.5,
    x2: 602.5,
    y2: 94.5,
    stroke: "url(#paint4_linear_4416_32947)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 18.5,
    y1: 65.5,
    x2: 585.5,
    y2: 65.5,
    stroke: "url(#paint5_linear_4416_32947)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 45.5,
    y1: 36.5,
    x2: 558.5,
    y2: 36.5,
    stroke: "url(#paint6_linear_4416_32947)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 99.5,
    y1: 7.5,
    x2: 504.5,
    y2: 7.5,
    stroke: "url(#paint7_linear_4416_32947)",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "2 40"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 41,
    width: 138,
    height: 137,
    rx: 68.5,
    fill: "#FCE9DE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_4416_32947)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 257,
    y: 89.3945,
    width: 69.702,
    height: 69.702,
    rx: 16,
    transform: "rotate(-20.4862 257 89.3945)",
    fill: "url(#paint8_linear_4416_32947)"
  }))), /*#__PURE__*/React.createElement("foreignObject", {
    x: 271.717,
    y: 85.9932,
    width: 67.9999,
    height: 68
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_4416_32947_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_ii_4416_32947)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.717,
    y: 89.9932,
    width: 60,
    height: 60,
    rx: 16,
    fill: "white",
    fillOpacity: 0.31
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.542 106.58H305.873M313.203 106.58H305.873M305.873 106.58V119.057M305.873 119.057H313.203M305.873 119.057V130.286C305.717 131.117 305.966 132.781 308.212 132.781C310.458 132.781 312.475 132.781 313.203 132.781",
    stroke: "white",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 286.754,
    y: 101.342,
    width: 11.7243,
    height: 9.85281,
    rx: 4.92641,
    stroke: "white",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 313.579,
    y: 103.214,
    width: 9.85281,
    height: 6.10982,
    rx: 3.05491,
    stroke: "white",
    strokeWidth: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 313.579,
    y: 116.314,
    width: 9.85281,
    height: 6.10982,
    rx: 3.05491,
    stroke: "white",
    strokeWidth: 2
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 313.579,
    y: 129.415,
    width: 9.85281,
    height: 6.10982,
    rx: 3.05491,
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4416_32947",
    x: 245.583,
    y: 57.584,
    width: 112.521,
    height: 112.521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4416_32947"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4416_32947",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_4416_32947"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.9
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.47 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_4416_32947",
    result: "effect3_innerShadow_4416_32947"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_4416_32947",
    x: 271.717,
    y: 85.9932,
    width: 67.9999,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_4416_32947"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_4416_32947",
    result: "effect2_innerShadow_4416_32947"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_4416_32947_clip_path",
    transform: "translate(-271.717 -85.9932)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 275.717,
    y: 89.9932,
    width: 60,
    height: 60,
    rx: 16
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4416_32947",
    x1: 98,
    y1: 211.5,
    x2: 506,
    y2: 211.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4416_32947",
    x1: 44,
    y1: 182.5,
    x2: 560,
    y2: 182.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4416_32947",
    x1: 17,
    y1: 153.5,
    x2: 587,
    y2: 153.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4416_32947",
    x1: 0,
    y1: 124.5,
    x2: 604,
    y2: 124.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4416_32947",
    x1: 0,
    y1: 96.5,
    x2: 604,
    y2: 96.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4416_32947",
    x1: 17,
    y1: 67.5,
    x2: 587,
    y2: 67.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4416_32947",
    x1: 44,
    y1: 38.5,
    x2: 560,
    y2: 38.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4416_32947",
    x1: 98,
    y1: 9.5,
    x2: 506,
    y2: 9.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.514423,
    stopColor: "#999999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4416_32947",
    x1: 291.851,
    y1: 89.3945,
    x2: 291.851,
    y2: 159.096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "var(--primary-color-text)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9631F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/Pattern.3aaa838033695f4ae39676e80cc061b4.svg";
export { ForwardRef as ReactComponent };